import { observer } from 'mobx-react'
import ThingsMenu from '../ThingsMenu'
import './index.scss'

import Select from '../../../common/Select/Select'
import { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import Option from '../../../common/Select/Option'
import ThingsCol from '../ThingsCol'
import { ReactComponent as Arrow } from '../../../../assets/arrow-left.svg'
import ServicesCol from '../../services/ServicesCol'
import TariffsCol from '../../tariffs/TariffsCol'
import ClearanceCol from '../../clearance/ClearanceCol'
import AcDocs from '../../ac-docs/AcCol'
import FaqCol from '../../faq/FaqCol'
import TerminalsCol from '../../terminals/TerminalsCol'
import GlobalState from '../../../../stores/GlobalState'
import { ReactComponent as Plus } from '../../../../assets/about/Vector.svg'
import ThingsScroll from '../ThingsScroll'
import classNames from 'classnames'
import SeoBlock from '../../../common/SeoBlock'

const ThingsContent = observer(
  ({
    content,
    menu,
    blocks,
    banners,
  }: {
    content: any
    menu: any
    blocks: any
    banners: any
  }) => {
    const { pathname } = useLocation()
    const [selectedTab, setSelectedTab] = useState(0)
    const navigate = useNavigate()
    const onSelectHandler = (selectedOption: string) => {
      if (!menu || !menu?.list?.length) return
      const _selectedTabId = menu?.list?.findIndex(
        (child: any) => child?.title === selectedOption,
      )
      if (_selectedTabId !== -1) {
        setSelectedTab(_selectedTabId)
      }
    }
    useEffect(() => {
      if (pathname && menu) {
        menu.list?.forEach((m: any, i: number) => {
          let link = m.link
          link = GlobalState.currentLocale.lang.includes('En')
            ? '/en' + link
            : GlobalState.currentLocale.lang.includes('ру')
            ? '/ru' + link
            : link
          if (link == pathname) {
            setSelectedTab(i)
          }
        })
      }
    }, [pathname, menu])

    const [width, setWidth] = useState(window.innerWidth)

    useEffect(() => {
      window.addEventListener('resize', () => setWidth(window.innerWidth))
    }, [])

    if (!content || !menu || !banners) return <></>

    let lang = GlobalState.currentLocale.lang.includes('En')
      ? '/en'
      : GlobalState.currentLocale.lang.includes('ру')
      ? '/ru'
      : ''

    let page = pathname.includes('for-you') ? '/for-you/' : '/for-business/'


    return (
      <section className="things">
        <div className="things__mobile">
          {menu && menu?.list && (
            <Select
              defaultValue={menu?.list[selectedTab].title}
              onSelect={onSelectHandler}
            >
              {menu?.list?.map((item: any, i: number) => {
                // if (
                //   item.title == menu?.list[selectedTab].title &&
                //   !pathname.includes('/offices/')
                // ) {
                //   return <Fragment key={i}></Fragment>
                // }

                let link = item.link.slice(1, item.link.length);
                link = GlobalState.currentLocale.lang.includes("En")
                  ? "en/" + link
                  : GlobalState.currentLocale.lang.includes("ру")
                  ? "ru/" + link
                  : link;

                if (!i)
                  return (
                    <div className="select-submenu">
                      {0 != selectedTab && (
                        <Option value={item.title} key={i} link={link}>
                          {item.title}
                        </Option>
                      )}
                      <div className="select-sublist">
                        {blocks?.map((bl: any, id: any) => (
                          <a
                            key={id}
                            href={lang + bl.linkblock}
                            className={classNames(
                              "select-option",
                              pathname == lang  + bl.linkblock &&
                                "active"
                            )}
                          >
                            <span className="marker"></span>
                            <span> {bl.info.catShort}</span>
                          </a>
                        ))}
                      </div>
                    </div>
                  );
                if (
                  item.title == menu?.list[selectedTab].title &&
                  !pathname.includes("/offices/")
                )
                  return <Fragment key={i}></Fragment>;
                return (
                  <Option value={item.title} key={i} link={link}>
                    {item.title}
                  </Option>
                );
              })}
            </Select>
          )}
          <a
            href={lang + "/offices/"}
            className="button grey-border things-menu__departs"
          >
            <Plus /> {menu?.departments}
          </a>
        </div>
        <div className="things__top">
          {banners?.map((b: any, i: number) => (
            <div className="things__top-block" key={i}>
              <img src={b.bg} alt="" />
              <div
                className="things__top-title"
                dangerouslySetInnerHTML={{ __html: b.title }}
              ></div>
              <a
                className="button black"
                href={b.buttonLink.replaceAll("#", "")}
                // onClick={() => {

                // if (pathname != `${lang}${page}`) {
                //   navigate(`${lang}${b.buttonLink}`)
                // } else {
                //   const sel = b.buttonLink.split('#')[1]
                //   const el = document.querySelector(`#${sel}`)
                //   if (!el) return
                //   const offset =
                //     (el as HTMLElement).getBoundingClientRect().top -
                //     document.body.getBoundingClientRect().top

                //   window.scrollTo({
                //     top: offset - 60,
                //     behavior: 'smooth',
                //   })
                // }
                // }}
              >
                {b.buttonTitle}
              </a>
            </div>
          ))}
        </div>

        <div className="things__row">
          {menu && blocks && <ThingsMenu menu={menu} blocks={blocks} />}
          {blocks && pathname == lang + page && (
            <ThingsScroll blocks={blocks} />
          )}

          <div className="things__row-col">
            {pathname == `${lang}${page}` && (
              <Fragment>
                {blocks.map((b: any, i: number) => (
                  <ThingsCol
                    key={i}
                    content={b.info}
                    linkblock={b.linkblock
                      .replaceAll("/for-you/", "")
                      .replaceAll("/for-business/", "")}
                  />
                ))}
              </Fragment>
            )}
            {pathname == `${lang}${page}services/` && (
              <Fragment>
                <ServicesCol />
              </Fragment>
            )}
            {pathname == `${lang}${page}tariffs/` && (
              <Fragment>
                <TariffsCol />
              </Fragment>
            )}
            {pathname == `${lang}${page}customs-clearance/` && (
              <Fragment>
                <ClearanceCol />
              </Fragment>
            )}
            {pathname == `${lang}${page}accompanying-documents/` && (
              <Fragment>
                <AcDocs />
              </Fragment>
            )}
            {pathname == `${lang}${page}faq/` && (
              <Fragment>
                <FaqCol />
              </Fragment>
            )}
            {pathname == `${lang}/offices/` && (
              <Fragment>
                <TerminalsCol />
              </Fragment>
            )}
            {content?.seo && content?.seo?.title?.length ? (
              <SeoBlock seo={content?.seo} isLight />
            ) : (
              <></>
            )}
          </div>
        </div>

        {width <= 480 && (
          <div
            className="team__bottom-arrow"
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          >
            <Arrow />
          </div>
        )}
      </section>
    );
  },
)

export default ThingsContent
